import { useTranslation } from '@mint-lib/i18n';

import { Chip, Tooltip, Truncation } from '@myn/mui';

import { UserType } from '../../../api/users/index.js';

export type Props = UserType & {
  onClick: (user: UserType) => void;
};

const LabelCell = ({ onClick, ...value }: Props) => {
  const { t } = useTranslation('@myn/permissions');

  const labels = value?.tags || [];

  return (
    <div className="nowrap flex gap-2">
      {labels[0] ? (
        <Truncation sx={{ maxWidth: '200px' }} tooltipTitle={labels[0].name}>
          <Chip label={labels[0].name} />
        </Truncation>
      ) : null}

      {labels.length > 1 && (
        <Tooltip title={t('View all labels')} placement="top">
          <Chip
            label={`+${labels.length - 1}`}
            onClick={() => onClick(value)}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default LabelCell;
